<template>
  <div
    aria-label="Progress"
    :aria-valuemax="maxValue"
    :aria-valuenow="value"
    class="w-full"
    data-test-id="vf-meter"
    role="meter"
    style="height: max-content"
  >
    <span
      v-if="minLabel || maxLabel"
      class="flex pb-1 text-xs between c-grey-10 fw-bold"
    >
      <span>{{ minLabel }}</span>
      <span>{{ maxLabel }}</span>
    </span>
    <span class="relative flex between">
      <span class="absolute top-1/2 w-full b-b b-grey-50" />
      <span
        v-for="key in maxValue"
        :key
        class="z-1 rounded-full i-block"
        :class="[key === value ? 'bg-grey-10 !bg-brand-2' : 'b b-grey-50 bg-white']"
        style="width: 0.625rem; height: 0.625rem"
      />
    </span>
  </div>
</template>

<script lang="ts" setup>
const {
  value = 3,
  maxValue = 5
}
  = defineProps<{
    /**
     * Defines current meter value
     */
    value?: number
    /**
     * Defines meter max value and determines number of steps rendered
     */
    maxValue?: number
    /**
     * Label for low end of meter
     */
    minLabel?: string
    /**
     * Label for high end of meter
     */
    maxLabel?: string
  }>()
</script>
